/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Website_Url1Inputs */

const vi_sitesettings_brand_website_url1 = /** @type {(inputs: Sitesettings_Brand_Website_Url1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ website (Mini App hiện ở chi tiết đơn)`)
};

/**

* @param {Sitesettings_Brand_Website_Url1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_website_url1 = /** @type {((inputs?: Sitesettings_Brand_Website_Url1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Website_Url1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_website_url1(inputs)
});
export { sitesettings_brand_website_url1 as "siteSettings_brand_website_url" }